export default __webpack_public_path__ + "static/media/1.40c92ace.jpg";